export default "__VITE_ASSET__d3435dc5__"